module.exports = __webpack_public_path__ + "img/file-pdf.40db3c54.svg";